import { ActionType, getType } from 'typesafe-actions';

import * as bulkDealNameUpdateActions from './action';
import { BulkDealNameUpdateResultData } from './action';

type BulkDealNameUpdateActionType = ActionType<typeof bulkDealNameUpdateActions>;

export interface BulkDealNameUpdateState {
  downloadTemplateLoading: boolean;
  submitLoading: boolean;
  result: BulkDealNameUpdateResultData | null;
}

const initialState: BulkDealNameUpdateState = {
  downloadTemplateLoading: false,
  submitLoading: false,
  result: null,
};

const bulkDealNameUpdateReducer = (
  state: BulkDealNameUpdateState = initialState,
  action: BulkDealNameUpdateActionType,
): BulkDealNameUpdateState => {
  switch (action.type) {
    case getType(
      bulkDealNameUpdateActions.getDownloadBulkDealNameUpdateTemplate.request,
    ):
      return { ...state, downloadTemplateLoading: true };
    case getType(
      bulkDealNameUpdateActions.getDownloadBulkDealNameUpdateTemplate.success,
    ):
    case getType(
      bulkDealNameUpdateActions.getDownloadBulkDealNameUpdateTemplate.failure,
    ):
      return { ...state, downloadTemplateLoading: false };

    case getType(bulkDealNameUpdateActions.submitBulkDealNameUpdate.request):
      return { ...state, submitLoading: true, result: null };
    case getType(bulkDealNameUpdateActions.submitBulkDealNameUpdate.success):
      return {
        ...state,
        submitLoading: false,
        result: action.payload.result,
      };
    case getType(bulkDealNameUpdateActions.submitBulkDealNameUpdate.failure):
      return { ...state, submitLoading: false };

    case getType(bulkDealNameUpdateActions.clearBulkDealNameUpdateResult):
      return { ...state, result: null };

    default:
      return state;
  }
};

export default bulkDealNameUpdateReducer;
